import { UserInfoWrapper } from "@/components/UserInfo/UserInfoWrapper";
import * as S from "@/containers/Project/components/styled";
import { faHexagonExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spin } from "antd";
import { bool, object, string } from "prop-types";
import { useState } from "react";

export const ReadOnlyUserInput = ({ user, loading, dataTestId }) => {
  const [dataTestIdPrefix] = useState(() =>
    dataTestId ? `${dataTestId}-` : ""
  );

  const { id, azureAdAccountEnabled, displayName } = user;

  return (
    <UserInfoWrapper user={user}>
      <S.ReadOnlyInput
        data-test-id={`${dataTestIdPrefix}read-only-user-input`}
        $color={id ? "#d1e9ff" : "#F0F0F0"}
        key={id}
        disabled={true}
        value={displayName}
        suffix={loading ? <Spin size="small" /> : undefined}
        prefix={
          !azureAdAccountEnabled &&
          displayName && (
            <FontAwesomeIcon icon={faHexagonExclamation} color="red" />
          )
        }
      />
    </UserInfoWrapper>
  );
};

ReadOnlyUserInput.propTypes = {
  user: object.isRequired,
  loading: bool,
  dataTestId: string,
};
